import React, { useState } from 'react';
import SidebarItem from './SideNavBar/SidebarItem';
import SidebarDropdown from './SideNavBar/SidebarDropdown';
import { useConfig } from '../DataStore/ConfigContext';
import RenderSecure from '../util/RenderSecure';
import '../assets/sidebar-polish.css';

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {

    const [activeDropdown, setActiveDropdown] = useState(null); // State to track active dropdown

    const {companyCode} = useConfig();


    return (
        <div className={`app-sidebar sidebar-shadow yx-sidebar ${isSidebarOpen ? "open yx-open" : "closed yx-closed"}`}>
            <div className="app-header__logo">
                <div className="logo-src"></div>
                <button className="hamburger close-sidebar-btn hamburger--elastic" onClick={toggleSidebar}>
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </button>
            </div>
            <div className="scrollbar-sidebar">
                <div className="app-sidebar__inner">
                    <ul className="vertical-nav-menu yx-nav">
                        <li className="app-sidebar__heading yx-heading">Business Manager</li>


                        {/* Dashboard */}
                        <SidebarItem path="/dashboard" iconClass="fa fa-chart-line" label="Finance" className="main-menu-item" />
                        {/* <SidebarItem path="/analytics" iconClass="fa fa-chart-line" label="Analytics" /> */}
                        {companyCode === 'GYM' && <>
                        <SidebarItem path="/gym" iconClass="fa fa-dumbbell" label="Gym Desk" className="main-menu-item"/>
                        <SidebarItem path="/gym-invoices" iconClass="fas fa-file-invoice-dollar" label="Sale Invoices" className="main-menu-item"/>
                        <SidebarItem path="/gym-customers" iconClass="fas fa-user-shield" label="Gym Customers" className="main-menu-item"/>
                        <SidebarItem path="/gym-finder" iconClass="fas fa-search" label="Customer Finder" className="main-menu-item"/>
                        <SidebarItem path="/gym-classes" iconClass="fa fa-dumbbell" label="Gym Classes" className="main-menu-item"/>

                        
                        </>}

                        <SidebarItem path="/report-daily-cashflow" iconClass="fas fa-calendar-alt " label="Daily Cash Flow" className="main-menu-item"/>
                        <SidebarItem path="/ledger-approval" iconClass="fas fa-check-circle" label="Ledger Approval" className="main-menu-item"/>


                        <li className="app-sidebar__heading yx-heading">Entries</li>
                        
                        {/* School Fees */}
                       {companyCode === 'SCHOOL' && <SidebarDropdown
                         iconClass="fa fa-handshake" 
                         label="School Fees" 
                         basePath="/school-fees"
                         activeDropdown={activeDropdown}
                         setActiveDropdown={setActiveDropdown}
                         id="school-fees"
                         className="main-menu-item"
                         >
                            <SidebarItem path="/school-fees-overview" iconClass="pe-7s-less nav-icon" label="Overview" />
                            <SidebarItem path="/school-fees-new" iconClass="pe-7s-less nav-icon" label="New Payment" />
                            <SidebarItem path="/school-fees-transactions" iconClass="pe-7s-less nav-icon" label="Transactions" />
                            <SidebarItem path="/school-fees-discounts" iconClass="pe-7s-less nav-icon" label="Fees Discounts" />
                            <SidebarItem path="/school-fees-advances" iconClass="pe-7s-less nav-icon" label="Advance Fees" />
                            <SidebarItem path="/school-fees-billing" iconClass="pe-7s-less nav-icon" label="Billing Center" />
                            <SidebarItem path="/school-fees-defaulters" iconClass="pe-7s-less nav-icon" label="Fees Defaulters" />
                            <SidebarItem path="/school-fees-students" iconClass="pe-7s-less nav-icon" label="Manage Students" />
                            <SidebarItem path="/school-fees-online" iconClass="pe-7s-less nav-icon" label="Online Payments" />
                            <SidebarItem path="/school-fees-wallet" iconClass="pe-7s-less nav-icon" label="Wallet Balances" />

                            
                        </SidebarDropdown>}

                        {/* Track Expenses */}
                        <SidebarDropdown 
                            iconClass="fa fa-upload" 
                            label="Track Expenses" 
                            basePath="/expenses"
                            activeDropdown={activeDropdown}
                            setActiveDropdown={setActiveDropdown}
                            id="expenses"
                            className="main-menu-item"
                            >
                            <RenderSecure code="ENTRY_CREATE">
                                <SidebarItem path="/expenses-new" iconClass="pe-7s-less nav-icon" label="New Expense" />
                            </RenderSecure>
                            <SidebarItem path="/expenses-invoicing" iconClass="pe-7s-less nav-icon" label="Incoming Invoices" />
                            <RenderSecure code="ENTRY_CREATE">
                                <SidebarItem path="/expenses-new-invoice" iconClass="pe-7s-less nav-icon" label="Record Invoice" />
                            </RenderSecure>
                        </SidebarDropdown>

                        {/* Track Income */}
                        <RenderSecure code="ENTRY_CREATE">
                            <SidebarDropdown iconClass="fa fa-download" label="Track Income" basePath="/income" activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} id="income" className="main-menu-item">
                                <SidebarItem path="/income-new" iconClass="pe-7s-less nav-icon" label="New Income" />
                            </SidebarDropdown>
                        </RenderSecure>

                        {/* Track Assets */}
                        <RenderSecure code="ENTRY_CREATE">
                            <SidebarDropdown iconClass="fa fa-building" label="Track Assets" basePath="/asset" activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} id="asset" className="main-menu-item">
                                <SidebarItem path="/asset-contra-new" iconClass="pe-7s-less nav-icon" label="New Contra" />
                                <SidebarItem path="/asset-new" iconClass="pe-7s-less nav-icon" label="New Asset" />
                                <SidebarItem path="/asset-appreciate" iconClass="pe-7s-less nav-icon" label="Appreciate Asset" />
                                <SidebarItem path="/asset-depreciate" iconClass="pe-7s-less nav-icon" label="Depreciate Asset" />
                            </SidebarDropdown>
                        </RenderSecure>

                        {/* Track Liabilities */}
                        <RenderSecure code="ENTRY_CREATE">
                            <SidebarDropdown iconClass="fa fa-briefcase" label="Track Liabilities" basePath="/liability" activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} id="liability" className="main-menu-item">
                                <SidebarItem path="/liability-new" iconClass="pe-7s-less nav-icon" label="Add Loan" />
                                <SidebarItem path="/liability-pay" iconClass="pe-7s-less nav-icon" label="Pay Loan" />
                            </SidebarDropdown>
                        </RenderSecure>
                        {/* Journal Entries */}
                        <RenderSecure code="ENTRY_CREATE">
                            <SidebarItem path="/transaction-journal-new" iconClass="fa fa-book" label="New Journal Entry" className="main-menu-item"/>
                        </RenderSecure>

                        <li className="app-sidebar__heading yx-heading">Applications</li>


                        {/* Vendors / Payees */}
                        <SidebarDropdown iconClass="fa fa-truck" label="Vendors / Payees" basePath="/vendor" activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} id="vendor" className="main-menu-item">
                            <SidebarItem path="/vendor-new" iconClass="pe-7s-less nav-icon" label="New Vendor" />
                            <SidebarItem path="/vendor-list" iconClass="pe-7s-less nav-icon" label="Vendor Listing" />
                        </SidebarDropdown>

                        {/* Ledger Tags */}
                        <SidebarItem path="/projects" iconClass="fa fa-tag" label="Projects (Tags)" className="main-menu-item"/>

                        {/* Chart Of Accounts */}
                        <SidebarDropdown iconClass="fa fa-project-diagram" label="Chart Of Accounts" basePath="/accounts" activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} id="accounts" className="main-menu-item">
                            <SidebarItem path="/accounts-chart" iconClass="pe-7s-less nav-icon" label="Hierarchical View" />
                            <SidebarItem path="/accounts-chart-tab" iconClass="pe-7s-less nav-icon" label="Tabular View" />
                        </SidebarDropdown>

                       {/* Banking */}
                       <SidebarDropdown iconClass="fa fa-credit-card" label="Banking" basePath="/banking" activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} id="banking" className="main-menu-item">
                            <SidebarItem path="/banking" iconClass="pe-7s-less nav-icon" label="Bank Accounts" />
                            <SidebarItem path="/banking-nexumpay" iconClass="pe-7s-less nav-icon" label="NexumPay Wallets" />
                            <SidebarItem path="/banking-transactions" iconClass="pe-7s-less nav-icon" label="Transactions" />
                        </SidebarDropdown>
                       
                        {/* Configurations */}
                        <RenderSecure code="MANAGE_SETTINGS">
                            <SidebarItem path="/settings" iconClass="fa fa-cog" label="System Settings" className="main-menu-item"/>
                        </RenderSecure>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
